/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Setpoint_Input_Mode_SetpointInputs */



/**
* | output |
* | --- |
* | "By setpoint" |
*
* @param {Air_Handler_Unit_Setpoint_Input_Mode_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_setpoint_input_mode_setpoint = /** @type {((inputs?: Air_Handler_Unit_Setpoint_Input_Mode_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Setpoint_Input_Mode_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("By setpoint")
	return /** @type {LocalizedString} */ ("Par consigne")
});